import { render, staticRenderFns } from "./VoiceMain.vue?vue&type=template&id=64ee76d4&"
import script from "./VoiceMain.vue?vue&type=script&lang=js&"
export * from "./VoiceMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports